import React from "react";
import { useLanguage } from "../../../../contexts/LanguageContext";

export function PosterIngredients({ ingredients, accentColor }) {
  const { t } = useLanguage();
  if (!ingredients?.length) return null;

  return (
    <div
      className="flex-shrink-0 rounded-lg flex flex-col overflow-hidden"
      style={{
        backgroundColor: accentColor,
        paddingTop: 10,
        paddingBottom: 14,
        paddingLeft: 10,
        paddingRight: 10,
        maxHeight: 140,
      }}
    >
      <div
        className="text-[10px] font-bold uppercase tracking-wider text-white/90 mb-2"
        style={{ paddingTop: 4, lineHeight: 1.6 }}
      >
        {t("ingredients")}
      </div>
      <ul
        className="text-[11px] text-white/95 space-y-0.5 overflow-y-auto pr-0.5 flex-1 min-h-0"
        style={{ lineHeight: 1.5, paddingBottom: 4 }}
      >
        {ingredients.map((ing, i) => (
          <li key={i} className="break-words">
            • {String(ing).trim()}
          </li>
        ))}
      </ul>
    </div>
  );
}
